const sectionPolicyAccordionBasicCss = `
[data-type='section-policy-accordion-basic'] * {
  box-sizing: border-box;
}

[data-type='section-policy-accordion-basic'] [data-attribute='card-container'][data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-policy-accordion-basic'] [data-attribute='card-container'][data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-policy-accordion-basic'] [data-attribute='card-container'] {
  color: var(--text-color, #000000);
}

[data-type='section-policy-accordion-basic'] .container-page[data-show-style='true'] {
  padding: 32px;
  border-radius: 20px;
  margin: auto;
  max-width: calc(100% - 32px);
  width: max-content;
}

[data-type='section-policy-accordion-basic'] h1,
[data-type='section-policy-accordion-basic'] h2,
[data-type='section-policy-accordion-basic'] h3 {
  font-size: 24px;
  line-height: 29px;
  margin: 0 0 9px 0 !important;
  color: #242424;
}

[data-type='section-policy-accordion-basic'] p {
  color: #6c6e72;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion {
  border-bottom: solid 1px #d4dceb;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  cursor: pointer;
  font-weight: bold;
  color: #242424;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-title div:first-child {
  width: calc(100% - 25px);
  font-size: 16px;
  font-weight: bold !important;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-title div:last-child {
  display: flex;
  border-radius: 50%;
  background-color: var(--text-color, #000000);
  color: #ffffff;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-title div:last-child svg {
  display: block;
  width: 18px;
  height: auto;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-title div:last-child.open {
  transform: rotate(-180deg);
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-content {
  max-height: 0;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

[data-type='section-policy-accordion-basic'] .wrap-card .wrap-accordion .accordion-content .accordion-text {
  padding: 10px;
}

@container (max-width: 768px) {
  [data-type='section-policy-accordion-basic'] [data-attribute='card-container'][data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-policy-accordion-basic'] [data-attribute='card-container'][data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-policy-accordion-basic'] .container-page[data-show-style='true'] {
    padding: 0;
  }

  [data-type='section-policy-accordion-basic'] h1,
  [data-type='section-policy-accordion-basic'] h2,
  [data-type='section-policy-accordion-basic'] h3 {
    font-size: 20px;
    line-height: 24px;
  }
}
`;
export default sectionPolicyAccordionBasicCss;
